import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig.js';

const environment = import.meta.env.MODE;

export default {
    libPath: environment === LOCAL ? `/public/lib/` : `/app/ai-tools/lib/`,
    originalSongKey: 'ai/input/music-generator/',
    resultSongKey: 'ai/export/music-generator/',
    waveformKey: 'ai/export/music-generator/waveform/',
    historyListType: 17,
    freeLimitType: 'music-generator',
    currentMenuName: 'ai-music-generator',

    coverPath:
        environment === LOCAL
            ? `/public/resource/AIAudio/cover/cover.png`
            : `/app/ai-tools/resource/AIAudio/cover/cover.png`,
    presetPreviewPath: environment === LOCAL ? `/public/resource/AIAudio/` : `/app/ai-tools/resource/AIAudio/`,
    presetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/AIAudio/presetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/AIAudio/presetList.json?v=${FJVersionConfig.staticPathVersion}`,
    referencePresetListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/AIAudio/referencePresetList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/AIAudio/referencePresetList.json?v=${FJVersionConfig.staticPathVersion}`,

    produceAudioWorkerPath:
        environment === LOCAL
            ? `/public/lib/audioWorker/produceAudio.js?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/lib/audioWorker/produceAudio.js?v=${FJVersionConfig.staticPathVersion}`,

    recordVideoPath:
        environment === LOCAL
            ? `/public/resource/AIAudio/record/record.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/resource/AIAudio/record/record.mp4?v=${FJVersionConfig.staticPathVersion}`,
};
